<template>
  <v-menu lazy>
    <!-- The button to show in the toolbar -->
    <template #activator="{ on }">
      <v-btn v-on="on" flat>
        <v-badge :color="badgeColor">
          <template v-if="showBadge" #badge>
            <v-icon>{{ badgeIcon }}</v-icon>
          </template>
          <v-icon :color="active ? 'blue' : 'black'">settings</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <!-- The default slot with the actual list with the options -->
    <v-list>
      <slot />
    </v-list>
  </v-menu>
</template>

<script>
/**
 * An abstract component to have a global "app settings" to work.
 *
 * It is recommended to follow a few architecture tips to work all ok:
 * - You must have an `appSettings` object in the store with all the
 *   global settings that your are app will use, so any component can
 *   access the values.
 * - As the settings could change the data of the app we recommend to
 *   use actions (that call the mutations) to change the values, where
 *   you want to dispatch other actions to update the data of the app.
 * - Each one of the options availables in this directory, that you can
 *   use in the default slot, follow this pattern by getting the value
 *   from the `appSettings` object from the namespaced store and updating
 *   it with an action like `setAppSettings<Name of the setting>`.
 * - The components provides mutations generator functions to easily
 *   integrate them in your store.
 * - You can provide your custom options to follow your own patterns.
 */
export default {
  props: {
    /* An active state could mean that there is any setting in a non null value and the
    icon of the menu will be blue */
    active: {
      type: Boolean,
      default: false
    },
    badgeColor: {
      type: String,
      default: "yellow"
    },
    badgeIcon: {
      type: String,
      default: "info"
    },
    /* Show a simple badge over the settings icon */
    showBadge: {
      type: Boolean,
      default: false
    }
  }
};
</script>
